import { useState, useEffect } from "react";
import {
  Popconfirm,
  Spin,
  message,
  Card,
  Row,
  Col,
  Empty,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { get, del } from "../../../services";

const { Meta } = Card;

const Blogstable = () => {
  const navigate = useNavigate();
  const [teamData, setTeamData] = useState([]);
  const [currentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const limit = 10;

  // Fetch API
  const getAllTeams = async (page) => {
    setLoader(true);
    try {
      const response = await get(`/team?page=${page}&limit=${limit}`);
      setTeamData(response?.data?.team || []);
    } catch (error) {
      message.error("Failed to fetch data");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllTeams(currentPage);
  }, [currentPage]);

  // Delete member
  const confirm = async (members, sectionIndex) => {
    setSelectedRecord(members._id);
    try {
      await del(`/team/${members._id}`);
      const updatedTeam = [...teamData];
      updatedTeam[sectionIndex].members = updatedTeam[sectionIndex].members.filter(
        (m) => m._id !== members._id
      );
      setTeamData(updatedTeam);
      message.success("Member deleted successfully");
    } catch (error) {
      message.error("Error deleting member");
    } finally {
      setSelectedRecord(null);
    }
  };

  const cancel = () => {};

  return (
    <div>
      <div className="header4">
        <h3>Team Members</h3>
        <div className="events-button">
          <Link to="/add-team">
            <button className="cursor-pointer add-event">Add Team Member</button>
          </Link>
        </div>
      </div>

      {loader ? (
        <div className="two-color-loader">
          <div className="spinner"></div>
        </div>
      ) : teamData.length > 0 ? (
        <>
          {teamData.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              <h3>{section.section}</h3>
              <Row gutter={24}>
                {section.members.map((member) => (
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={8}
                    xxl={5}
                    key={member._id}
                  >
                    <Card
                      hoverable
                      style={{
                        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                        margin: "15px 0px",
                      }}
                      cover={
                        <img
                          alt={member.fullName}
                          src={member?.imageUrl}
                          className="card-img-height"
                        />
                      }
                      actions={[
                        <EditOutlined
                          key="edit"
                          onClick={() => navigate("/edit-team/" + member._id)}
                          className="delete-icon-admin"
                        />,
                        selectedRecord === member._id ? (
                          <Spin key="spin" />
                        ) : (
                          <Popconfirm
                            title="Delete the member"
                            description="Are you sure to delete this member?"
                            onConfirm={() => confirm(member, sectionIndex)}
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <DeleteFilled
                              key="delete"
                              className="cursor-pointer delete-icon-admin"
                            />
                          </Popconfirm>
                        ),
                      ]}
                    >
                      <Meta
                        title={member.fullName}
                        description={
                          <div
                            className="truncate-description"
                            dangerouslySetInnerHTML={{
                              __html:
                                member?.title && member?.title !== "null"
                                  ? member?.title
                                  : "",
                            }}
                          />
                        }
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ))}

          {/* Pagination */}
          {/* <Pagination
            current={currentPage}
            total={teamData.reduce((sum, sec) => sum + sec.members.length, 0)}
            pageSize={limit}
            onChange={(page) => setCurrentPage(page)}
            className="pagination"
          /> */}
        </>
      ) : (
        <div className="no-data">
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="spin-center2" />
        </div>
      )}
    </div>
  );
};

export default Blogstable;
